import { IconTypes } from 'components';
import { ICurrentEmployee } from 'store/types';
import { IEmployee, IPaymentTotals, PaymentWorkflowTypes, PermissionType } from 'types';

export enum MakePaymentStep {
  SelectDate = 'select-date',
  SelectPayees = 'select-payees',
  FileUpload = 'file',
  PaymentInput = 'input',
  PaymentReview = 'review',
}

export interface MakePaymentProps {
  currentSiteId?: string;
  currentEmployee?: ICurrentEmployee;
  businessDate?: string;
  pageHeaderContent: React.ReactNode;
  totals?: IPaymentTotals;
  onNext?: () => void;
  onBack?: () => void;
  onAddPayees?: (employees: IEmployee[]) => void;
  onRemovePayee?: (index: number) => void;
}

export interface PayoutMethodOption {
  type: PaymentWorkflowTypes;
  desc: string;
  icon: IconTypes;
  permission: PermissionType;
}

export const payoutMethodOptions: PayoutMethodOption[] = [
  {
    type: PaymentWorkflowTypes.STANDARD,
    desc: 'Make a payment manually by adding your employees and their tip amounts.',
    icon: 'CustomDial',
    permission: PermissionType.PAYMENT_CREATE_STANDARD,
  },
  {
    type: PaymentWorkflowTypes.UPLOAD,
    desc: 'Upload a CSV file to make payments.',
    icon: 'Upload',
    permission: PermissionType.PAYMENT_CREATE_UPLOAD,
  },
  {
    type: PaymentWorkflowTypes.CALCULATOR,
    desc: 'Make payments with this site’s tip calculation policy.',
    icon: 'Calculator',
    permission: PermissionType.PAYMENT_CREATE_CALCULATOR,
  },
];
